import { annotationToolApiV1 } from '../annotationToolApi';
import { getAnnotationToolBasePath } from '../routePaths';
import type { ListResponse, User } from '../types/responseTypes';

const ELIGIBLE_PEOPLE_TAG = 'eligible-people';

export const eligiblePeopleApiSlice = annotationToolApiV1
  .enhanceEndpoints({
    addTagTypes: [ELIGIBLE_PEOPLE_TAG],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
      getAnnotators: builder.query<ListResponse<User>, { includeNonAssignable?: boolean } | void>({
        query: ({ includeNonAssignable } = {}) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;
          const query = includeNonAssignable
            ? `?include_non_assignable=${includeNonAssignable}`
            : '';

          return `${tempPath}/manage-projects/annotators${query}`;
        },
        providesTags: [ELIGIBLE_PEOPLE_TAG],
      }),

      getSupervisors: builder.query<ListResponse<User>, { includeNonAssignable?: boolean } | void>({
        query: ({ includeNonAssignable } = {}) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;
          const query = includeNonAssignable
            ? `?include_non_assignable=${includeNonAssignable}`
            : '';

          return `${tempPath}/manage-projects/supervisors${query}`;
        },
        providesTags: [ELIGIBLE_PEOPLE_TAG],
      }),
    }),
  });

export const { useGetAnnotatorsQuery, useGetSupervisorsQuery } = eligiblePeopleApiSlice;
